import React from "react";
import { Container, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { LoadingComponent } from "../../Components/Loading";
import routes from "../../Helpers/Routes.json";
import { useOrders } from "../../Shared/Hooks/useOrders";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../Shared/helpers/currency";

function OrdersPage() {
  const { orders, loading } = useOrders([]);
  const { t } = useTranslation();

  const wooStatus = {
    pending: t("Pendiente de cobro"),
    processing: t("Procesando"),
    "on-hold": t("En espera"),
    completed: t("Completado"),
    cancelled: t("Cancelado"),
    refunded: t("Reembolsado"),
    failed: t("Fallido"),
  };

  return (
    <Container className="py-4" style={{ maxWidth: "800px" }}>
      <h1 className="h3 fw-bold mb-4">{t("Mis pedidos")}</h1>

      {loading ? (
        <LoadingComponent />
      ) : orders.length ? (
        <div className="card p-0 overflow-hidden">
          <Table className="table-striped mb-0">
            <thead>
              <tr>
                <th>{t("Pedido")}</th>
                <th>{t("Fecha")}</th>
                <th>{t("Estado")}</th>
                <th>{t("Total")}</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr key={order.id} className="position-relative">
                  <td>
                    <Link
                      to={routes.OrdersPage.detail.replace(":order", order.id)}
                      className="stretched-link text-decoration-none fw-medium"
                    >
                      #{order.id}
                    </Link>
                  </td>
                  <td className="small">
                    {new Date(order.date_created).toLocaleDateString()}
                  </td>
                  <td>
                    <span
                      className={`badge rounded-pill ${
                        order.status === "completed"
                          ? "bg-success"
                          : order.status === "cancelled" || order.status === "failed"
                          ? "bg-danger"
                          : order.status === "processing"
                          ? "bg-warning text-dark"
                          : "bg-secondary"
                      }`}
                    >
                      {wooStatus[order.status]}
                    </span>
                  </td>
                  <td className="fw-medium">
                    {formatCurrency(parseFloat(order.total))}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ) : (
        <div className="text-center py-5">
          <p className="text-muted">
            {t("Aún no has hecho ningún pedido.")}
          </p>
        </div>
      )}
    </Container>
  );
}

export default OrdersPage;
